import React from "react";
import "../ReporteDocente.css";

const ObservacionesSection = ({ docente }) => {
  const tieneFortalezas = docente.fortalezas?.some((f) => f.trim() !== "");
  const tieneOportunidades = docente.oportunidadMejora?.some((o) => o.trim() !== "");

  if (!tieneFortalezas && !tieneOportunidades) return null;

  return (
    <div className="card fortalezas-oportunidades-autovaloracion">
      <div className="superior">
        {/* Oportunidades */}
        {tieneOportunidades && (
          <div className="oportunidades">
            <h3>Oportunidades de Mejora</h3>
            {docente.oportunidadMejora
              .filter((item) => item.trim() !== "")
              .map((item, index) => (
                <div key={index} className="opportunidad-item">
                  <i className="fas fa-exclamation-circle"></i>
                  <span>{item}</span>
                </div>
              ))}
          </div>
        )}

        {/* Línea Divisoria */}
        <div className="linea-divisoria"></div>

        {/* Fortalezas */}
        {tieneFortalezas && (
          <div className="fortalezas">
            <h3>Fortalezas</h3>
            {docente.fortalezas
              .filter((item) => item.trim() !== "")
              .map((item, index) => (
                <div key={index} className="fortaleza-item">
                  <i className="fas fa-check-circle"></i>
                  <span>{item}</span>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ObservacionesSection;
